import { createSlice } from '@reduxjs/toolkit';


const themeColor= localStorage.getItem("theme")?? "light"
document.documentElement.setAttribute('data-theme', themeColor);

const initialState = {
    themeColor: themeColor 
};

const generalSlice = createSlice({
    name: "general",
    initialState,
    reducers: {
        changeThemeToggle(state, action) {
            let c = state.themeColor === "dark" ? "light" : "dark"
            document.documentElement.setAttribute('data-theme', c);
            document.body.setAttribute('data-theme-change', 'true');
            setTimeout(() => {
                document.body.removeAttribute('data-theme-change');
            }, 300); // Match the CSS transition duration
            localStorage.setItem("theme", c);

            state.themeColor = c
        }
    }
})

export const generalActions = generalSlice.actions;
export default generalSlice
